/**
 * @copyright (C) Microsoft Corporation.
 * All Rights Reserved.
 */

export const specialties: string[] = [
    "Addiction Medicine",
    "Advanced Heart Failure and Transplant",
    "Allergy & Immunology",
    "Anesthesiology",
    "Cardiac Surgery",
    "Cardiology",
    "Cardiovascular Disease/Cardiology",
    "Clinical Cardiac Electrophysiology",
    "Colorectal Surgery",
    "Colorectal Surgery (Proctology)",
    "Critical Care Medicine",
    "Dermatology",
    "Diagnostic Radiology",
    "Emergency Medicine",
    "Endocrinology",
    "Family Medicine",
    "Family Practice",
    "Gastroenterology",
    "General Surgery",
    "Geriatric Medicine",
    "Geriatric Psychiatry",
    "Gynecological Oncology",
    "Hand Surgery",
    "Hematology",
    "Hematology & Oncology",
    "Hospice and Palliative Care",
    "Hospitalist",
    "Infectious Disease",
    "Internal Medicine",
    "Interventional Cardiology",
    "Interventional Pain Management",
    "Interventional Radiology",
    "Maxillofacial Surgery",
    "Medical Oncology",
    "Medical Toxicology",
    "Nephrology",
    "Neurological Surgery/Neurosurgery",
    "Neurology",
    "Neuropsychiatry",
    "Neurosurgery",
    "Nuclear Medicine",
    "Obstetrics & Gynecology",
    "Ophthalmology",
    "Orthopedic Surgery",
    "Osteopathic Manipulative Medicine",
    "Other",
    "Otolaryngology",
    "Pain Management",
    "Pain Medicine & Pain Management",
    "Pathology",
    "Pediatric Medicine",
    "Peripheral Vascular Disease",
    "Physical Medicine & Rehabilitation",
    "Plastic and Reconstructive Surgery",
    "Plastic Surgery",
    "Preventative Medicine",
    "Preventive Medicine",
    "Psychiatry",
    "Pulmonary Disease/Pulmonology",
    "Radiation Oncology",
    "Radiology & Diagnostic Radiology",
    "Rheumatology",
    "Sleep Medicine",
    "Sports Medicine",
    "Surgical Oncology",
    "Thoracic Surgery",
    "Urology",
    "Vascular Surgery"
];
